module.exports = __webpack_public_path__ + "static/media/BaseCheese.204b89ab.png";